export function validateSelection(value){
    if(value === ""){
        return "Selecciona una opción\n"
    }

    return '';
}